import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmProvider";
import { CheckinProvider } from "@/components/CheckinProvider";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AppShell from "@/pages/AppShell";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
        <Loader2 className="w-8 h-8 animate-spin text-[#1E3A8A]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to="/app" replace />;
}

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <CheckinProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/login" element={<Login />} />
              <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CheckinProvider>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
